import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const IndustrySelectionSection = ({ formData, errors, onChange }) => {
  const industryOptions = [
    { value: 'technology', label: 'Technology & Software' },
    { value: 'healthcare', label: 'Healthcare & Medical Services' },
    { value: 'finance', label: 'Finance & Banking' },
    { value: 'retail', label: 'Retail & E-commerce' },
    { value: 'education', label: 'Education & Training' },
    { value: 'real-estate', label: 'Real Estate & Property' },
    { value: 'hospitality', label: 'Hospitality & Tourism' },
    { value: 'manufacturing', label: 'Manufacturing & Production' },
    { value: 'consulting', label: 'Consulting & Professional Services' },
    { value: 'media', label: 'Media & Entertainment' },
    { value: 'food-beverage', label: 'Food & Beverage' },
    { value: 'automotive', label: 'Automotive & Transportation' },
    { value: 'construction', label: 'Construction & Engineering' },
    { value: 'energy', label: 'Energy & Utilities' },
    { value: 'telecommunications', label: 'Telecommunications' },
    { value: 'agriculture', label: 'Agriculture & Farming' },
    { value: 'legal', label: 'Legal Services' },
    { value: 'nonprofit', label: 'Non-Profit & Social Services' },
    { value: 'other', label: 'Other' }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Briefcase" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-xl sm:text-2xl font-semibold text-foreground font-heading">
            Industry Selection
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground mt-1">
            Help us understand your industry for targeted recommendations and best practices
          </p>
        </div>
      </div>

      <div className="space-y-6">
        <Select
          label="Primary Industry"
          description="Select the industry that best describes your business"
          placeholder="Choose your industry"
          options={industryOptions}
          value={formData?.industry || ''}
          onChange={(value) => onChange('industry', value)}
          error={errors?.industry}
          required
          searchable
        />

        <Input
          type="text"
          label="Sub-Industry or Niche"
          description="Specify your specific market segment or specialization (Optional)"
          placeholder="e.g., SaaS for healthcare, Organic food delivery, B2B consulting"
          value={formData?.subIndustry || ''}
          onChange={(e) => onChange('subIndustry', e?.target?.value)}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-4 bg-success/10 rounded-lg border border-success/20">
          <div className="flex items-start gap-2">
            <Icon name="TrendingUp" size={18} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">Industry Insights</p>
              <p className="text-xs text-muted-foreground">
                Our Marketing Agent will analyze high-performing content and strategies specific to your industry
              </p>
            </div>
          </div>
        </div>

        <div className="p-4 bg-primary/10 rounded-lg border border-primary/20">
          <div className="flex items-start gap-2">
            <Icon name="Target" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">Competitive Analysis</p>
              <p className="text-xs text-muted-foreground">
                Feedback Agent will benchmark your performance against industry standards and competitors
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 bg-muted/50 rounded-lg border border-border">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm text-muted-foreground flex-1 min-w-0">
            <p className="font-medium text-foreground mb-1">How this helps:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Discover industry-specific marketing templates and ad copy</li>
              <li>Get competitor insights and performance benchmarks</li>
              <li>Receive recommendations based on industry best practices</li>
              <li>Access curated content relevant to your market</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustrySelectionSection;